@if ((tabs$ | async); as tabs) {
<div class="d-none d-lg-block">
  @if (tabs.length > 1) {
  <ul
    class="nav nav-tabs nav-justified nav-fill flex-column flex-lg-row {{
      type
    }}"
    role="tablist"
  >
    @if (!isTaxComponent) { @for (tab of tabs; track tab) {
    <li class="nav-item" role="presentation">
      <a
        tabindex="0"
        role="tab"
        class="nav-link {{
          tab.status
        }} d-flex flex-row justify-content-center h-100"
        [class.active]="isActive(tab)"
        (click)="onNavigate(tab)"
        [attr.aria-current]="isActive(tab) ? ('PAGE' | globalTranslate) : null"
        [attr.aria-selected]="isActive(tab)"
      >
        <span class="tab-section"
          >{{ getTabTitle(tab) | globalTranslate }}
        </span>
      </a>
    </li>
    } } @if (isTaxComponent) { @for (tab of tabs; track tab) {
    <li class="nav-item" role="presentation">
      <a
        tabindex="0"
        role="tab"
        class="nav-link2 {{
          tab.status
        }} d-flex flex-row justify-content-center h-100"
        [class.active]="isActive(tab)"
        (click)="onNavigate(tab)"
        [attr.aria-current]="isActive(tab) ? ('PAGE' | globalTranslate) : null"
        [attr.aria-selected]="isActive(tab)"
      >
        <span class="tab-section"
          >{{ getTabTitle(tab) | globalTranslate }}
        </span>
      </a>
    </li>
    } }
  </ul>
  }
</div>
}